module.exports = __webpack_public_path__ + "img/FotoGrinsen.9c739cba.jpg";